import React from 'react';

/*
  ContactPage — minimal contact page.
  Props: navigateTo, goBack
*/
const ContactPage = ({ navigateTo, goBack }) => {
  return (
    <div style={{
      minHeight: '100vh', backgroundColor: 'var(--bg)', paddingTop: '80px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '120px 24px 80px',
    }}>
      <div style={{
        backgroundColor: 'var(--bg-secondary)',
        border: '1px solid var(--border)',
        borderRadius: '16px',
        padding: '48px 40px',
        maxWidth: '440px',
        width: '100%',
        textAlign: 'center',
      }}>
        {/* Back */}
        <button
          onClick={() => goBack ? goBack() : navigateTo('company')}
          style={{
            background: 'none', border: 'none', color: 'var(--text-tertiary)',
            fontSize: '13px', fontWeight: 500, cursor: 'pointer', padding: 0,
            fontFamily: 'inherit', transition: 'color 0.2s',
            display: 'block', marginBottom: '32px', textAlign: 'left',
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--text-primary)'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--text-tertiary)'}
        >← Back</button>

        <h1 style={{
          fontFamily: 'Georgia, "Times New Roman", serif',
          fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 400,
          color: 'var(--text-primary)', lineHeight: 1.2,
          margin: '0 0 12px', letterSpacing: '-0.01em',
        }}>Get in touch</h1>

        <p style={{
          fontSize: '16px', color: 'var(--text-secondary)',
          lineHeight: 1.65, margin: '0 0 36px',
        }}>
          We'd love to hear from you.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {/* Email */}
          <a
            href="mailto:hello@axigon.ai"
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: '10px', padding: '14px 20px',
              backgroundColor: 'var(--bg)', border: '1px solid var(--border)',
              borderRadius: '10px', textDecoration: 'none',
              color: 'var(--text-primary)', fontSize: '14px', fontWeight: 500,
              transition: 'border-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--text-tertiary)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
          >
            <span style={{ fontSize: '16px' }}>✉️</span>
            <span>hello@axigon.ai</span>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/919999999999"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: '10px', padding: '14px 20px',
              backgroundColor: 'var(--accent)', border: '1px solid var(--accent)',
              borderRadius: '10px', textDecoration: 'none',
              color: '#ffffff', fontSize: '14px', fontWeight: 600,
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'var(--accent-hover)'; e.currentTarget.style.borderColor = 'var(--accent-hover)'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'var(--accent)'; e.currentTarget.style.borderColor = 'var(--accent)'; }}
          >
            <span style={{ fontSize: '16px' }}>💬</span>
            <span>Chat on WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
